<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
    <template #DETAILS="{ visible, params }">
      <Tracker v-if="visible" :statusId="params.row.airway_number"></Tracker>
    </template>
    <template #header>
      <Tabs v-if="isShow()" v-model="tabName" @on-click="handleTab">
        <TabPane :label="$t('n_process')" name="0" />
        <TabPane :label="$t('y_process')" name="1" />
      </Tabs>
      <Tabs v-else v-model="tabName" @on-click="handleTab">
        <TabPane label="Wait to process" name="AGENT" />
        <TabPane label="Processed" name="FINISHED" />
      </Tabs>
    </template>

    <template #UPLOADED="{ params }">
      <Row v-if="params.img && params.img.length" type="flex" justify="start">
        <Col
          v-for="item in params.img"
          :key="item.id"
          span="4"
          class="demo-upload-list"
          style="padding: 0; margin: 0; font-size: 0; margin-right: 10px"
        >
          <img style="width: 100%" :src="item.src" />
          <div class="demo-upload-list-cover" style="padding: 0; margin: 0">
            <Icon type="ios-eye-outline" @click.native="openImg(item.src)">
            </Icon>
            <Icon
              v-if="!params.is_delete"
              type="ios-trash-outline"
              @click.native="delUploadFile(item.id, params)"
            >
            </Icon>
          </div>
        </Col>
      </Row>
      <template v-if="params.doc && params.doc.length">
        <div
          @click="openFile(item.src)"
          v-for="item in params.doc"
          :key="item.id"
          class="div-hover"
        >
          <span> {{ item.name }}</span>
          <Icon
            v-if="!params.is_delete"
            @click.stop="delUploadFile(item.id, params)"
            class="icon-close"
            size="20"
            type="ios-close"
          />
        </div>
      </template>
    </template>
  </cTable>
</template>

<script>
import { getAllClient, getCompanies } from "@/api/user/client";
import { getUser } from "@/api/user/internal";
import {
  getNewError,
  createExceptionBatch,
  getFinishError,
  addRemark,
  remarkList,
  getAwbCountry,
  createException,
  getSelf,
  getFollowList,
  checkOrder,
  batchAudit,
  set_plan1,
  updateAppointment
} from "@/api/order/list";
import { getSelectType } from "@/api/public";
import { getCountry } from "@/api/system/country";
import Tracker from "@/base/order_tracker";
import { getAgent } from "@/api/tracker/agent";
import { getCity } from "@/api/system/city";
import { getAllService } from "@/api/user/internal";
import { returnFun } from "@/api/ffc/ffcShipments";
import cTable from "@/base/common/index";
export default {
  name: "orderError",
  components: {
    cTable,
    Tracker
  },
  async mounted() {
    this.$refs["table"].tabName = this.tabName;
    this.$refs["table"].virtualCountry = [];
    this.followType = (
      await getSelectType("EXCEPTION_FOLLOW_TYPE")
    ).data.payload["EXCEPTION_FOLLOW_TYPE"];
    this.header.searchs.forEach(async item => {
      if (item.key === "follow_type") {
        item.options = this.followType;
      }
      if (item.key === "cod_type") {
        item.options = await this.$sel.getData("COD_TYPE");
      }
    });
    this.modals.follow.fields.forEach(item => {
      if (item.key === "follow_type") {
        item.options = this.followType.slice(1, this.followType.lengt);
      }
    });
    this.$refs["table"].virtualCountry = [];
    getSelectType("VIRTUAL_WAREHOUSE").then(res => {
      console.log(res);
      if (res.data.status) {
        this.$refs["table"].virtualCountry = res.data.payload[
          "VIRTUAL_WAREHOUSE"
        ].map(item => item.country);
      }
    });
  },
  methods: {
    handleTab(tab) {
      // console.log(this);
      this.$refs["table"].tabName = this.tabName;
      this.$refs["table"].getList();
    },
    isShow() {
      return this.$route.name != "abnormalShipments";
    }
  },
  data() {
    let errorObj = [
        "orther",
        "finished",
        "byCustomer",
        "byOverseasWarehouseListed",
        "byOverseasWarehousePicking",
        "byCallCenter",
        "byService"
      ],
      codType = [
        {
          value: "NCND",
          label: "到付"
        },
        {
          value: "NOR",
          label: "预付"
        }
      ],
      podType = ["NO", "YES"],
      pickupList = [
        {
          value: 1,
          label: this.$t("YES")
        },
        {
          value: 0,
          label: this.$t("NO")
        }
      ];
    return {
      followType: [],
      tabName: this.isShow() ? "0" : "AGENT",
      ffcTabName: "AGENT",
      methods: {
        list: params => {
          params = JSON.parse(JSON.stringify(params));
          if (!this.isShow()) {
            params["deliver"] = "FFC";
            params["deal"] = this.tabName;
          } else {
            params["is_finished"] = this.tabName;
            this.$refs["table"].toCountry = params.toCountry;
            this.$refs["table"].city_id = params.toCountry;
            this.$refs["table"].is_pickup = params.is_pickup;
          }
          if (params.plan) {
            params.second_plan = params.plan[1];
            params.plan = params.plan[0];
          }
          return getNewError(params);
        },
        getAllClient,
        getUser,
        getSelectType,
        getFinishError,
        addRemark,
        remarkList,
        getAwbCountry,
        getCity,
        createException,
        createExceptionBatch,
        getSelf,
        getFollowList,
        checkOrder,
        batchAudit,
        set_plan1,
        returnFun,
        updateAppointment
        // getDetails
      },
      config: {
        height: 630
      },
      modals: {
        follow: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("checkOrder", row, true)
                .then(res => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              follow_type: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              follow_remark: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("finish") + this.$t("abnormal"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ follow_type: 24 }, { follow_remark: 24 }],
          fields: [
            {
              key: "follow_type",
              name: () => this.$t("auditOrder") + this.$t("type"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") + this.$t("auditOrder") + this.$t("type")
                );
              },
              options: []
              // config: {
              //   label: ({ row }) => {
              //     return this.$t(row.label);
              //   }
              // }
            },
            {
              key: "follow_remark",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        finish: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("getFinishError", row, true)
                .then(res => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              deal: [
                {
                  required: true,
                  // type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              remarks: [
                {
                  required: false,
                  message: "cannot be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("finish") + this.$t("abnormal"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ deal: 24 }],
          fields: [
            {
              key: "deal",
              name: () => this.$t("tip"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("tip");
              },
              options: [
                {
                  value: "WAIT",
                  label: "customerProcessed"
                },
                {
                  value: "SERVICE",
                  label: "serviceProcessed"
                },
                {
                  value: "AGENT",
                  label: "agentProcessed"
                },
                {
                  value: "FINISHED",
                  label: "finished"
                }
              ],
              config: {
                label: ({ row }) => {
                  return this.$t(row.label);
                }
              }
            }
            // {
            //   key: "remarks",
            //   name: () => this.$t("order_desc"),
            //   component: "Input",
            //   placeholder() {
            //     return this.$t("enter") + this.$t("order_desc");
            //   },
            //   bind: {
            //     type: "textarea",
            //     rows: 5
            //   }
            // }
          ]
        },
        addRemark: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addRemark", row, true)
                .then(res => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              remarks: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("add") + this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              key: "remarks",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        show: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600
            }
          },
          footer: { show: () => false }
        },
        showRemark: {
          config: {
            listFn: "remarkList",
            modalBind: {
              width: 600
            },
            title: "order_desc",
            modalContentBind: {
              style: "height:60vh;overflow-x:hidden;overflow-y:auto;"
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 500
            },
            fields: [
              {
                name: () => this.$t("serviceAccount"),
                key: "operator_name",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("order_desc"),
                key: "remarks",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("addTo") + this.$t("time"),
                key: "remarks_time",
                align: "center",
                tooltip: true,
                minWidth: 100,
                methods: {
                  render({ value }) {
                    return ~~value ? this.format.timeFormat(value * 1000) : "-";
                  }
                }
              }
            ]
          }
        },
        detail: {
          slots: ["UPLOADED"],
          methods: {
            ok({ row, close }) {
              let newData = {
                type: "detail",
                feedback_number: row.feedback_number,
                staff_id: row.staff_id,
                content: row.content,
                feedback_id: row.id,
                files: row.files
              };
              let data = new FormData();
              for (const key in newData) {
                if (key === "files" && newData[key]) {
                  for (var i = 0; i < newData[key].length; i++) {
                    data.append("files[]", newData[key][i]); // 文件对象
                  }
                } else if (key === "staff_id" && newData[key]) {
                  for (var i = 0; i < newData[key].length; i++) {
                    data.append("staff_id[]", newData[key][i]); // 文件对象
                  }
                } else {
                  if (newData[key]) {
                    data.append(key, newData[key]);
                  }
                }
              }
              let obj = {
                method: "get",
                feedback_id: row.id
              };
              this.$page
                .handleRequestMethods("addAssistPlatform", data, true)
                .then(() => {
                  this.getList(obj);
                  this.$store.commit("remindFun", true);
                  this.$refs["form"].clear();
                  // close();
                });
            }
          },
          footer: {
            ok: {
              name: this.$t("order_submit")
            }
          },
          config: {
            listFn: "detail",
            title: "detail",
            modalContentBind: {
              style: "height:80vh;overflow-x:hidden;overflow-y:auto;"
            },
            modalBind: {
              width: "80%",
              styles: {
                top: "30px"
              }
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              content: [
                {
                  required: true,
                  message: "airway number cannot be empty",
                  trigger: "blur"
                }
              ]
              // staff_id: [
              //   {
              //     required: false,
              //     type: "array",
              //     message: "staff cannot be empty",
              //     trigger: "blur"
              //   }
              // ]
            }
          },
          grid: [
            // {
            //   name: () => this.$t("feedbackArea"),
            //   span: 10,
            //   children: [
            //     {
            //       cause: 24
            //     },
            //     {
            //       message: 24
            //     },
            //     {
            //       uploaded: 24
            //     }
            //   ]
            // },
            {
              name: () => this.$t("FollowArea"),
              span: 24,
              children: [
                {
                  department: 8,
                  staff_id: 16
                },
                {
                  content: 24
                },
                {
                  airway_number: 24
                },
                {
                  files: 24
                }
              ]
            }
            // { cause: 10, department: 6, staff_id: 8 },
            // { message: 10, content: 14 },
            // { uploaded: 10, files: 14 }
            // { leftNull: 10, files: 14 }
          ],
          fields: [
            {
              name: () => this.$t("assistDepartment"),
              key: "department",
              component: "Select",
              bind: {
                multiple: true
              },
              placeholder: () =>
                this.$t("select") + this.$t("assistDepartment"),
              options: [],
              methods: {
                "on-change"({ fields, value, row }) {
                  fields.forEach(async item => {
                    if (item.key === "staff_id") {
                      getUserList({ department: value }).then(res => {
                        item.options = res.data.payload;
                      });
                      row.staff_id = [];
                      this.$forceUpdate();
                    }
                  });
                }
              }
            },
            {
              name: () => this.$t("needAssistPerson"),
              key: "staff_id",
              component: "Select",
              bind: {
                multiple: true
              },
              placeholder: () =>
                this.$t("select") + this.$t("needAssistPerson"),
              options: []
            },
            {
              name: () => this.$t("ReasonFeedback"),
              key: "cause",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("ReasonFeedback"),
              bind: {
                type: "textarea",
                autosize: { minRows: 1, maxRows: 4 }
              },
              disabled: true
            },
            {
              name: () => this.$t("need") + this.$t("AssistContent"),
              key: "message",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("need") + this.$t("AssistContent"),
              disabled: true,
              bind: {
                type: "textarea",
                autosize: { minRows: 1, maxRows: 4 }
              }
            },
            {
              name: () => this.$t("FollowCase"),
              key: "content",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 4
              },
              placeholder: () => this.$t("enter") + this.$t("FollowCase")
            },
            {
              name: () => this.$t("orderNum"),
              key: "airway_number",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 2
              },
              placeholder: () => this.$t("enter") + this.$t("orderNum")
            },
            {
              name: () => this.$t("updateFile") + this.$t("files"),
              key: "files",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: true,
                isButton: true,
                type: "select",
                accept: ".xlsx,.xls,.doc,.docx,.pdf,.jpg,.png,.jpeg,.gif"
              },
              methods: {
                beforeUpload({ file, row }) {
                  if (row["files"]) row["files"].push(file);
                  else row["files"] = [file];
                  return false;
                }
              }
            },
            {
              name: () => this.$t("uploaded"),
              key: "uploaded",
              solt: "UPLOADED"
            }
          ],
          table: {
            config: {
              align: "center",
              height: 300
            },
            footer: {
              show: true
            },
            fields: [
              {
                name: () => this.$t("FollowPerson"),
                key: "staff",
                align: "left",
                headerAlign: "left",
                tooltip: true,
                width: 130
              },
              {
                name: () => this.$t("FollowTime"),
                key: "create_time",
                align: "left",
                headerAlign: "left",
                tooltip: true,
                width: 150
              },
              {
                name: () => this.$t("FollowCase"),
                key: "message",
                align: "left",
                headerAlign: "left",
                tooltip: true
              },
              // {
              //   name: () => this.$t("Appendix"),
              //   align: "center",
              //   tooltip: true,
              //   width: 150,
              //   component: "Button",
              //   bind: {
              //     type: "primary",
              //     size: "small"
              //   },
              //   disabled: ({ row }) => {
              //     return (
              //       row.img && !row.img.length && row.doc && !row.doc.length
              //     );
              //   },
              //   methods: {
              //     render({ row }) {
              //       return "查看";
              //     },
              //     click({ row }) {
              //       this.$page.getModal("appendix").open(row);
              //     }
              //   }
              // },
              // {
              //   name: () => this.$t("FollowTime"),
              //   key: "create_time",
              //   align: "center",
              //   tooltip: true,
              //   width: 150
              // },
              // {
              //   name: () => this.$t("FollowPerson"),
              //   key: "staff",
              //   align: "center",
              //   tooltip: true,
              //   width: 130
              // },
              {
                name: () => this.$t("operation"),
                type: "btns",
                width: 150,
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("Appendix"),
                    type: "appendix",
                    fnName: "appendix",
                    bind: {
                      type: "primary"
                    },
                    disabled: ({ row }) => {
                      return (
                        row.img && !row.img.length && row.doc && !row.doc.length
                      );
                    }
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    bind: {
                      type: "error"
                    }
                  }
                ],
                methods: {
                  appendix({ row }) {
                    this.getModal("appendix").open(row);
                  },
                  // update({ row }) {
                  //   row["method"] = "get";
                  //   let obj = {
                  //     method: "get",
                  //     id: row.id
                  //   };
                  //   this.handleRequestMethods("list", obj).then(res => {
                  //     this.getModal("add").setTitle(this.$t("update"));
                  //     let data = res.payload;
                  //     data["method"] = "put";
                  //     this.getModal("add").open(data);
                  //   });
                  // },
                  delete({ row }) {
                    this.$Modal.confirm({
                      title:
                        this.$t("whether") +
                        this.$t("confirm") +
                        this.$t("delete") +
                        this.$t("createTime") +
                        "：" +
                        row.create_time +
                        this.$t("assistOrder") +
                        "?",
                      onOk: () => {
                        this.handleRequestMethods(
                          "detail",
                          {
                            id: row.id,
                            method: "delete",
                            feedback_id: row.feedback_id
                          },
                          true
                        ).then(res => {
                          // this.$Message.success(res.data.msg);
                          let obj = {
                            method: "get",
                            feedback_id: row.feedback_id
                          };
                          this.getModal("detail").getList(obj);
                        });
                      }
                    });
                  }
                }
              }
            ]
          }
        },
        plan: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("getSelf", row).then(res => {
                this.$Message.success("success");
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 700
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("TO_WMS"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              second_plan: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ]
            }
          },
          grid: [{ second_plan: 24 }],
          fields: [
            {
              key: "second_plan",
              name: "退件方案",
              component: "Radio",
              options: []
            }
          ]
        },
        errorHandle: {
          methods: {
            ok({ row, close }) {
              if (this.type === "add") {
                if (!row.done)
                  return this.$Message["error"]({
                    content: this.$t("correctOrderNumber"),
                    background: true
                  });
                this.fields.forEach(field => {
                  if (field.key === "exception_msg") {
                    field.options.forEach(item => {
                      if (item.value === row[field.key])
                        row.exception_type_msg = item.label;
                    });
                  }
                });
                this.$page
                  .handleRequestMethods("createException", row)
                  .then(res => {
                    this.$Message.success("success");
                    this.$page.getList();
                    close();
                  });
                return;
              }
              let data = this.handleFilterData({
                airway_number: row.order_id,
                toCountry: row.toCountry
              });
              this.$page.handleRequestMethods("set_plan1", data).then(res => {
                this.$Message.success("success");
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 700
            },
            formBind: {
              labelWidth: 100
            },
            title: "异常订单新增",
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              // client_id: [
              //   {
              //     required: true,
              //     message: "cannot be empty",
              //     trigger: "change",
              //     type: "number"
              //   }
              // ],
              exception_msg: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { airway_number: 24 },
            { plan: 24 },
            { second_plan: 24 },
            { update_flag: 24 },
            { status: 24 },
            // { client_id: 24 },
            { exception_msg: 24 },
            { city: 24 },
            { consignee_contact: 12, consignee_cellular: 12 },
            { consignee_telephone: 24 },
            { consignee_address: 24 },
            { reserve_time: 12 },
            { remarks: 24 }
          ],
          fields: [
            {
              key: "plan",
              name: () => this.$t("handle") + this.$t("plan"),
              component: "Radio",
              options: [],
              show() {
                return this.$modal.type !== "add";
              },
              methods: {
                list({ row, field }) {
                  let isVirtual = this.$page.virtualCountry.includes(
                    this.$modal.params.toCountry
                  );
                  field.options = this.$page.plans.filter(item => {
                    return this.$modal.params.is_pickup
                      ? item.value === "PICKUP"
                      : item.value === "TRANSFER"
                      ? ["QA", "KW", "OM", "BH"].includes(
                          this.$modal.params.toCountry
                        )
                      : item.value !== "PICKUP" &&
                        (["SelfHandle", "Destroy"].includes(item.value)
                          ? isVirtual
                          : true);
                  });
                },
                "on-change"({ fields, value, formData, field }) {
                  if (!formData.update_flag)
                    fields.forEach(async item => {
                      if (item.key === "city")
                        item.options = (
                          await this.$page.handleRequestMethods("getCity", {
                            country_code: this.$modal.params.toCountry
                          })
                        ).payload.rows;
                      if (item.key === "second_plan") {
                        let options = field.options.find(
                          t => t.value === value
                        );
                        if (options && options.children) {
                          item.options = options.children;
                          item.show_t = true;
                        } else {
                          formData[item.key] = "";
                          item.show_t = false;
                        }
                      }
                    });
                }
              }
            },
            {
              key: "second_plan",
              name: "退件方案",
              component: "Radio",
              show_t: false,
              show({ field, formData }) {
                return formData["plan"] && field.show_t;
              },
              options: []
            },
            {
              key: "update_flag",
              name: () => this.$t("orderInfo") + this.$t("modify"),
              component: "Radio",
              show({ formData }) {
                return (
                  ["DELIVERY", "PICKUP"].includes(formData.plan) &&
                  this.$modal.type !== "add"
                );
              },
              options: [
                { label: this.$t("unNeed"), value: "NO" },
                { label: this.$t("need"), value: "YES" }
              ]
            },
            {
              key: "airway_number",
              name: () => this.$t("orderNum"),
              component: "Input",
              show() {
                return this.$modal.type === "add";
              },
              placeholder: () => this.$t("enter") + this.$t("orderNum"),
              methods: {
                "on-blur"({ fields, value, formData }) {
                  fields.forEach(async item => {
                    if (item.key === "city" && value) {
                      formData.city = "";
                      formData.status = "";
                      item.options = [];
                      getAwbCountry({ airway_number: value }).then(
                        async res => {
                          if (res.data.status) {
                            formData.done = true;
                            formData.status = res.data.payload.status;
                            item.options = (
                              await this.$page.handleRequestMethods("getCity", {
                                country_code: res.data.to_country
                              })
                            ).payload.rows;
                          } else {
                            formData.airway_number = "";
                            formData.done = false;
                          }
                        }
                      );
                      // let result = (
                      //   await this.$page.handleRequestMethods("getAwbCountry", {
                      //     airway_number: value
                      //   })
                      // ).payload;

                      // formData.status = true;
                      // formData.status = result.status;
                    }
                  });
                }
              }
            },
            // {
            //   key: "client_id",
            //   component: "Select",
            //   name: () => this.$t("clientName"),
            //   placeholder() {
            //     return this.$t("select") + this.$t("clientName");
            //   },
            //   clearable: true,
            //   options: [],
            //   config: { label: "account", value: "id" },
            //   methods: {
            //     async list({ field }) {
            //       let res = (await getAllClient()).data.payload;
            //       field.options = res.rows;
            //       this.$forceUpdate();
            //     }
            //   }
            // },
            {
              key: "status",
              name: () => this.$t("order_t") + this.$t("status"),
              component: "Input",
              show() {
                return this.$modal.type === "add";
              },
              placeholder:
                this.$t("auto_acquire") +
                this.$t("order_t") +
                this.$t("exlType"),
              disabled: true
            },
            {
              key: "exception_msg",
              name: () => this.$t("warehouse_status"),
              placeholder: () =>
                this.$t("select") + this.$t("warehouse_status"),
              component: "Select",
              show({ formData }) {
                return this.$modal.type === "add";
              },
              options: [],
              data: "CUSTOM_EXCEPTION",
              bind: {
                "label-in-value": true
              },
              methods: {
                list({ field }) {
                  this.$page
                    .handleRequestMethods("getSelectType", field.data)
                    .then(res => {
                      field.options = res.payload[field.data];
                    });
                }
              }
            },
            {
              key: "city",
              name: () => this.$t("city_name"),
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("city_name"),
              options: [],
              show({ formData }) {
                console.log(
                  formData.exception_msg !== "stop delivery",
                  formData.exception_msg
                );
                return (
                  (["DELIVERY"].includes(formData.plan) &&
                    formData.update_flag === "YES") ||
                  (this.$modal.type === "add" &&
                    formData.exception_msg !== "stop delivery")
                );
              },
              config: {
                label: "title",
                value: "title"
              }
            },
            {
              key: "consignee_contact",
              name: () => this.$t("order_recivre"),
              component: "Input",
              show({ formData }) {
                return (
                  (["DELIVERY", "PICKUP"].includes(formData.plan) &&
                    formData.update_flag === "YES") ||
                  (this.$modal.type === "add" &&
                    formData.exception_msg !== "stop delivery")
                );
              },
              placeholder: () => this.$t("enter") + this.$t("order_recivre")
            },
            {
              key: "consignee_cellular",
              name: () => this.$t("order_phone"),
              component: "Input",
              disabled({ formData }) {
                return !!formData.consignee_address;
              },
              show({ formData }) {
                return (
                  (["DELIVERY", "PICKUP"].includes(formData.plan) &&
                    formData.update_flag === "YES") ||
                  (this.$modal.type === "add" &&
                    formData.exception_msg !== "stop delivery")
                );
              },
              formItemBind: {
                rules: [{ message: "格式必须纯数字", pattern: /^[0-9]+$/ }]
              },
              placeholder: () => this.$t("enter") + this.$t("order_phone")
            },
            {
              key: "consignee_telephone",
              name: this.$t("order_phone1"),
              component: "Input",
              disabled({ formData }) {
                return !!formData.consignee_address;
              },
              formItemBind: {
                rules: [{ message: "格式必须纯数字", pattern: /^[0-9]+$/ }]
              },
              show({ formData }) {
                return (
                  (["DELIVERY", "PICKUP"].includes(formData.plan) &&
                    formData.update_flag === "YES") ||
                  (this.$modal.type === "add" &&
                    formData.exception_msg !== "stop delivery")
                );
              },
              placeholder: () => this.$t("enter") + this.$t("order_phone1")
            },
            {
              key: "consignee_address",
              name: this.$t("order_address"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              show({ formData }) {
                return (
                  (["DELIVERY", "PICKUP"].includes(formData.plan) &&
                    formData.update_flag === "YES") ||
                  (this.$modal.type === "add" &&
                    formData.exception_msg !== "stop delivery")
                );
              },
              disabled({ formData }) {
                return (
                  !!formData.consignee_cellular ||
                  !!formData.consignee_telephone
                );
              },
              placeholder: () => this.$t("enter") + this.$t("order_address")
            },
            {
              key: "reserve_time",
              name: () => this.$t("appointmentDate"),
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("appointmentDate"),
              bind: {
                options: {
                  disabledDate(time) {
                    return time.getTime() < Date.now();
                  }
                }
              },
              show({ formData }) {
                return (
                  (["DELIVERY", "PICKUP"].includes(formData.plan) &&
                    formData.update_flag === "YES") ||
                  (this.$modal.type === "add" &&
                    formData.exception_msg !== "stop delivery")
                );
              },
              methods: {
                format({ value }) {
                  return value && this.format.customTime(value, "YYYY-MM-DD");
                }
              }
            },
            {
              key: "remarks",
              name: this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              show({ formData }) {
                return (
                  (this.$modal.type === "add" &&
                    formData.exception_msg !== "stop delivery") ||
                  (["DELIVERY", "PICKUP"].includes(formData.plan) &&
                    formData.update_flag === "YES")
                );
              },
              placeholder: () => this.$t("enter") + this.$t("Remarks")
            }
          ]
        },
        batchErrorHandle: {
          methods: {
            ok({ row, close }) {
              this.fields.forEach(field => {
                if (field.key === "exception_msg") {
                  field.options.forEach(item => {
                    if (item.value === row[field.key])
                      row.exception_type_msg = item.label;
                  });
                }
              });
              this.$page
                .handleRequestMethods("createExceptionBatch", row)
                .then(res => {
                  this.$Message.success("success");
                  this.$page.getList();
                  close();
                })
                .catch(err => {
                  console.log(err);
                  this.$Message.error({
                    content: err.data.msg,
                    duration: 0,
                    closable: true
                  });
                });
            }
          },
          config: {
            modalBind: {
              width: 700
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("orderError") + this.$t("batch") + this.$t("add"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              // client_id: [
              //   {
              //     required: true,
              //     message: "cannot be empty",
              //     trigger: "change",
              //     type: "number"
              //   }
              // ],
              exception_msg: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { airway_number: 24 },
            // { client_id: 24 },
            { exception_msg: 24 },
            { reserve_time: 12 },
            { remarks: 24 }
          ],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("orderNum"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              placeholder: () => this.$t("enter") + this.$t("orderNum")
            },
            // {
            //   key: "client_id",
            //   component: "Select",
            //   name: () => this.$t("clientName"),
            //   placeholder() {
            //     return this.$t("select") + this.$t("clientName");
            //   },
            //   clearable: true,
            //   options: [],
            //   config: { label: "account", value: "id" },
            //   methods: {
            //     async list({ field }) {
            //       let res = (await getAllClient()).data.payload;
            //       field.options = res.rows;
            //       this.$forceUpdate();
            //     }
            //   }
            // },
            {
              key: "exception_msg",
              name: () => this.$t("warehouse_status"),
              placeholder: () =>
                this.$t("select") + this.$t("warehouse_status"),
              component: "Select",
              options: [],
              data: "CUSTOM_EXCEPTION",
              bind: {
                "label-in-value": true
              },
              methods: {
                list({ field }) {
                  this.$page
                    .handleRequestMethods("getSelectType", field.data)
                    .then(res => {
                      res.payload[field.data].splice(0, 1);
                      field.options = res.payload[field.data];
                    });
                }
              }
            },
            {
              key: "reserve_time",
              name: () => this.$t("appointmentDate"),
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("appointmentDate"),
              bind: {
                options: {
                  disabledDate(time) {
                    return time.getTime() < Date.now();
                  }
                }
              },
              methods: {
                format({ value }) {
                  return this.format.customTime(value, "YYYY-MM-DD");
                }
              }
            },
            {
              key: "remarks",
              name: this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              placeholder: () => this.$t("enter") + this.$t("Remarks")
            }
          ]
        },
        showFollow: {
          config: {
            modalBind: {
              width: 60
            },
            title: "order_desc",
            modalContentBind: {
              style: "height:60vh;overflow-x:hidden;overflow-y:auto;"
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 500
            },
            fields: [
              {
                name: () => this.$t("Remarks") + this.$t("type"),
                key: "remarks_type",
                align: "center",
                tooltip: true,
                width: 120
              },
              {
                name: () => this.$t("follow") + this.$t("Remarks"),
                key: "remarks",
                align: "center",
                tooltip: true,
                minWidth: 130
              },
              {
                name: () => this.$t("FollowTime"),
                key: "create_time",
                align: "center",
                tooltip: true,
                width: 150
              },
              {
                name: () => this.$t("FollowPerson"),
                key: "create_name",
                align: "center",
                tooltip: true,
                width: 120
              }
            ]
          }
        },
        audit: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("batchAudit", row, true)
                .then(res => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              follow_type: [
                {
                  required: true,
                  type: "number",
                  trigger: "change"
                }
              ],
              remarks: [
                {
                  required: true,
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("batchAudit"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ follow_type: 24 }, { follow_remark: 24 }],
          fields: [
            {
              key: "follow_type",
              name: () => this.$t("auditOrder") + this.$t("type"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") + this.$t("auditOrder") + this.$t("type")
                );
              },
              methods: {
                async list({ field }) {
                  let res = (await getSelectType("EXCEPTION_FOLLOW_TYPE")).data
                    .payload["EXCEPTION_FOLLOW_TYPE"];
                  res = res.filter(item => item.value != 1);
                  field.options = res;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "follow_remark",
              name: () => this.$t("Remarks"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        update: {
          methods: {
            ok({ row, close }) {
              console.log(row);
              let requireKey = ["start_time", "city", "phone", "address"];
              let isTrue = requireKey.find(t => row[t]);
              if (!isTrue) {
                return this.$Message.error({
                  content: this.$t("all empty"),
                  background: true
                });
              }
              this.$page
                .handleRequestMethods("updateAppointment", row, true, true)
                .then(res => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              follow_type: [
                {
                  required: true,
                  type: "number",
                  trigger: "change"
                }
              ],
              remarks: [
                {
                  required: true,
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("batchAudit"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [
            { start_time: 24 },
            { city: 24 },
            { phone: 24 },
            { address: 24 }
          ],
          fields: [
            {
              key: "city",
              name: () => this.$t("city_t"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("city_t");
              },
              config: {
                label: "title",
                value: "title"
              },
              options: [],
              methods: {
                async list({ field, formData, row }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCity", {
                      country_code: this.$modal.params.country_code
                    })
                  ).payload.rows;
                }
              }
            },
            {
              key: "phone",
              name: () => this.$t("phone"),
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("phone")
            },
            {
              key: "address",
              name: () => this.$t("address"),
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("address")
            },
            {
              key: "start_time",
              name: () => this.$t("appointmentDate"),
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("appointmentDate"),
              bind: {
                options: {
                  disabledDate(time) {
                    return (
                      time.getTime() < Date.now() ||
                      time.getTime() > Date.now() + 86400 * 1000 * 31
                    );
                  }
                }
              },
              methods: {
                format({ value }) {
                  return value && this.format.customTime(value, "YYYY-MM-DD");
                }
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "time_type",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("time") + this.$t("type");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["EXCEPTION_SELECT_TIME"])).data
                  .payload["EXCEPTION_SELECT_TIME"];
                field.options = res;
                searchForm["time_type"] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "start_time",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "end_time",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm["endTime"] = time;
                }
              }
            }
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
            methods: {
              async list({ field }) {
                let res = (await getAllClient()).data.payload;
                field.options = res.rows;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "exception_msg",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("Abnormal Message");
            },
            options: [
              { value: 1, label: this.$t("phoneError") },
              { value: 2, label: this.$t("addressError") }
            ]
          },
          {
            key: "ownership",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
            bind: {
              style: "width:150px"
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getCompanies()).data.payload;
                field.options = res;
                this.$forceUpdate();
              }
            },
            show: this.isShow
          },
          {
            key: "service_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            options: [],
            // config: {
            //   label: "account",
            //   value: "id",
            // },
            methods: {
              async list({ field }) {
                let res = (await getAllService()).data.payload;
                let arr = [1, 2, 3];
                let data = [];
                arr.forEach(item => {
                  data = data.concat(res[item]);
                });
                field.options = data;
                this.$forceUpdate();
              }
            },
            show: this.isShow
          },
          {
            key: "source",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("source");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["EXCEPTION_SOURCE"])).data
                  .payload["EXCEPTION_SOURCE"];
                field.options = res;
                this.$forceUpdate();
              }
            },
            show: this.isShow
          },
          {
            key: "deliver",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("localFaction");
            },
            options: [],
            config: { label: "agent_name", value: "agent_name" },
            methods: {
              async list({ field }) {
                field.options = (
                  await getAgent({ agent_type: "bag" })
                ).data.payload.rows;
                this.$forceUpdate();
              }
            },
            show: this.isShow
          },
          {
            key: "cod_type",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("order_type");
            },
            options: [],
            show: this.isShow
            // config: { label: ({ row }) => this.$t(row.desc), value: "key" }
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            methods: {
              async list({ field }) {
                let res = (await getAllService()).data.payload;
                let arr = [5];
                let data = [];
                arr.forEach(item => {
                  data = data.concat(res[item]);
                });
                field.options = data;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "toCountry",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("countryCode");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            methods: {
              async list({ field }) {
                let res = (await getCountry()).data.payload;
                this.$page.toCountry = res.rows;
                field.options = res.rows;
                this.$forceUpdate();
              }
            },
            show: this.isShow
          },
          {
            key: "plan",
            component: "Cascader",
            placeholder() {
              return this.$t("select") + this.$t("plan");
            },
            options: [],
            bind: {
              data: [],
              style: "width:150px",
              "change-on-select": true
            },
            show: () => {
              return this.tabName == 1;
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["EXCEPTION_CALL_PLAN_NEW"]))
                  .data.payload["EXCEPTION_CALL_PLAN_NEW"];
                res.forEach(item => {
                  this.$page.header.btns.list.push({
                    type: item.value,
                    name: item.label,
                    fnName: "handle",
                    bind: {
                      type: "success"
                    },
                    id: 904,
                    children: item.children,
                    show() {
                      return this.$page.tabName == "0"
                        ? ~~this.$page.is_pickup && item.value !== "PICKUP"
                          ? false
                          : item.value === "TRANSFER"
                          ? ["QA", "KW", "OM", "BH"].includes(
                              this.$page.toCountry
                            )
                          : ["SelfHandle", "Destroy"].includes(item.value)
                          ? this.$page.virtualCountry.includes(
                              this.$page.toCountry
                            )
                          : true
                        : false;
                    },
                    disabled() {
                      return !this.selectAll.length;
                    }
                  });
                });
                field.options = res;
                field.bind.data = res;
                this.$page.plans = res;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "deal",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("process_status");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["EXCEPTION_CALL_STATUS"])).data
                  .payload["EXCEPTION_CALL_STATUS"];
                field.options = res;
                this.$forceUpdate();
              }
            },
            show: () => {
              return this.tabName == "1" && this.isShow();
            }
          },
          {
            key: "status",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("pickingStatus");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["EXCEPTION_PICKUP_STATUS_OMS"]))
                  .data.payload["EXCEPTION_PICKUP_STATUS_OMS"];
                field.options = res;
                this.$forceUpdate();
              }
            },
            show: () => {
              return this.tabName == "1" && this.isShow();
            }
          },
          // {
          //   key: "exceptionType",
          //   placeholder() {
          //     return this.$t("enter") + this.$t("exception_code");
          //   },
          //   component: "Input"
          // },
          // {
          //   key: "exceptionStatus",
          //   placeholder() {
          //     return this.$t("enter") + this.$t("exception_status");
          //   },
          //   component: "Input"
          // },

          {
            key: "is_pickup",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("whether") + this.$t("returnException");
            },
            options: pickupList
          },
          {
            key: "follow_type",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("auditOrder") + this.$t("tip");
            },
            options: [],
            show: () => {
              return this.tabName == "1";
            }
            // config: {
            //   label: ({ row }) => {
            //     return this.$t(row.label);
            //   }
            // }
          },
          {
            key: "is_new",
            placeholder() {
              return this.$tz("最新,异常");
            },
            component: "Select",
            options: [],
            optionsFn: "YesNoNumber",
            optionsKey: "",
            show: () => {
              return this.tabName == "1";
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
              // autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                type: "success"
              }
            },
            {
              name: () => this.$t("BulkAdd"),
              type: "bulkAdd",
              fnName: "bulkAdd",
              bind: {
                type: "success"
              }
            },
            {
              name: () => this.$t("reviseProcessStatus"),
              type: "finish",
              fnName: "finishFun",
              id: 578,
              disabled() {
                return !this.selectAll.length;
              },
              show: () => {
                return this.tabName == "1";
              },
              bind: {
                type: "success"
              }
            },
            {
              name: () => this.$t("add") + this.$t("order_desc"),
              type: "remark",
              fnName: "remarkFun",
              id: 579,
              disabled() {
                return !this.selectAll.length;
              },
              show: () => {
                return this.tabName == "1";
              },
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("self_mention"),
              type: "selfMention",
              fnName: "selfMentionFun",
              id: 904,
              disabled() {
                return !this.selectAll.length;
              },
              show: () => {
                return this.tabName != "1";
              },
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("batchAudit"),
              type: "audit",
              fnName: "auditFun",
              id: 999,
              disabled() {
                return !this.selectAll.length;
              },
              show: () => {
                return this.tabName == "1";
              },
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            add() {
              this.getModal("errorHandle").open({}, function() {
                this.type = "add";
              });
            },
            bulkAdd() {
              this.getModal("batchErrorHandle").open({}, function() {
                this.type = "add";
              });
            },
            export() {
              this.exportExc();
            },
            finishFun() {
              let data = {
                details: this.selectAll.map(item => {
                  return {
                    airway_number: item.airway_number,
                    plan: item.plan
                  };
                }),
                source: 1,
                id: this.selectAll.map(item => item.id)
              };
              this.getModal("finish").open(data);
            },
            remarkFun() {
              let airway_number = this.selectAll.map(
                item => item.airway_number
              );
              this.getModal("addRemark").open({ airway_number });
            },
            auditFun() {
              const data = {
                id: this.selectAll.map(item => item.id)
              };
              this.getModal("audit").open(data);
            },
            selfMentionFun() {
              this.$Modal.confirm({
                title: this.$t("self_mention"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let airway_number = this.selectAll.map(
                    item => item.airway_number
                  );
                  let data = {
                    airway_number,
                    plan: "SelfHandle"
                  };
                  this.handleRequestMethods("getSelf", data, true, true).then(
                    res => {
                      this.getList();
                    }
                  );
                }
              });
            },
            handle({ searchForm, field }) {
              let airway_number = this.selectAll.map(
                item => item.airway_number
              );
              if (field.children) {
                this.getModal("plan").open(
                  {
                    plan: field.type,
                    airway_number,
                    toCountry: this.toCountry
                  },
                  function() {
                    console.log(this);
                    this.fields[0].options = field.children;
                  }
                );
                return;
              }
              this.$Modal.confirm({
                title: field.name,
                content: this.$t(field.type + "_TIP"),
                onOk: () => {
                  this.handleRequestMethods("getSelf", {
                    plan: field.type,
                    airway_number,
                    toCountry: this.toCountry
                  }).then(res => {
                    this.$Message.success({
                      content: "success",
                      background: true
                    });
                    this.getList();
                  });
                }
              });
              // this.$page.handleRequestMethods('batchSetplan',row).then(res=>{
              //   this.$Message["success"]({
              //     background: true,
              //     content: res.msg,
              //     duration: 5
              //   });
              //   this.$page.getList()
              //   close()
              // })
              // this.getModal('handle').open({airway_number,toCountry:this.city_id})
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("orderNum"),
          key: "airway_number",
          // component: "Button",
          copy: true,
          align: "center",
          fixed: "left",
          header: {
            copy: true //头部复制
          },
          // bind: {
          //   type: "primary",
          //   size: "small"
          // },
          showOverflow: false,
          width: 160,
          // methods: {
          //   click({ row }) {
          //     this.$page.getModal("show").setTitle(row.airway_number);
          //     this.$page.getModal("show").open({ row });
          //   }
          // },
          render: (h, p) => {
            return h(
              "Button",
              {
                props: {
                  type: p.row.is_multi_source ? "error" : "primary",
                  size: "small"
                },
                on: {
                  click: () => {
                    this.$refs["table"]
                      .getModal("show")
                      .setTitle(p.row.airway_number);
                    this.$refs["table"].getModal("show").open({ row: p.row });
                  }
                }
              },
              p.row.airway_number
            );
          }
        },
        {
          name: () => this.$t("b2bClient") + this.$t("Odd_Numbers"),
          key: "client_refer_code",
          align: "center",
          copy: ({ row }) => {
            return row.client_refer_code;
          },
          align: "center",
          fixed: "left",
          header: {
            copy: true //头部复制
          },
          width: 120
        },
        {
          name: () => this.$t("abnormal") + this.$t("source"),
          key: "source_flag",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("exception_time"),
          key: "exception_time",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("exception_msg"),
          key: "exception_msg_cn",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("daysRemaining"),
          key: "lave_number",
          align: "center",
          minWidth: 100,
          show: () => {
            return this.tabName === "0";
          }
        },
        {
          name: () => this.$t("returnException"),
          key: "is_pickup",
          align: "center",
          minWidth: 80,
          methods: {
            render({ row }) {
              return this.$t(row.is_pickup == 1 ? "YES" : "NO");
            }
          }
        },
        {
          name: () => this.$t("auditOrder") + this.$t("tip"),
          key: "follow_type",
          align: "center",
          minWidth: 80,
          show: () => {
            return this.tabName === "1";
          }
          // methods: {
          //   render({ row }) {
          //     return row.follow_type
          //       ? this.followType[row.follow_type]
          //         ? this.followType[row.follow_type].label
          //         : row.follow_type
          //       : " ";
          //   }
          // }
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          header: {
            copy: true //头部复制
          },
          width: 120
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          align: "center",
          minWidth: 140,
          show: this.isShow
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "service_name",
          align: "center",
          minWidth: 100,
          show: this.isShow
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "country_code",
          align: "center",
          minWidth: 130,
          show: this.isShow
        },
        {
          name: () => this.$t("localFaction"),
          key: "deliver",
          align: "center",
          minWidth: 100,
          show: this.isShow
        },
        {
          name: () => this.$t("plan"),
          key: "plan",
          align: "center",
          show: () => {
            return this.tabName == "1";
          },
          minWidth: 100
        },
        {
          name: () => this.$t("subplan") + this.$t("time"),
          key: "plan_time",
          align: "center",
          show: () => {
            return this.tabName == "1";
          },
          minWidth: 140,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("Appointment"),
          key: "specified_time",
          align: "center",
          minWidth: 140,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("order_recivre"),
          key: "consignee_customer",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("order_phone"),
          key: "consignee_telephone",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("order_phone1"),
          key: "consignee_telephone2",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("order_address"),
          key: "consignee_address",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("order_address1"),
          key: "consignee_address2",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("process_status"),
          key: "status",
          align: "center",
          minWidth: 100,
          show: () => {
            return this.tabName == "1" && this.isShow();
          }
          // methods: {
          //   render({ row }) {
          //     return this.$t(errorObj[row.status]);
          //   }
          // }
        },
        {
          name: () => this.$t("service") + this.$t("order_desc"),
          key: "remarks",
          align: "center",
          component: "a",
          minWidth: 110,
          methods: {
            async click({ row }) {
              let res = await this.$page.handleRequestMethods("remarkList", {
                airway_number: row.airway_number
              });
              this.$page.getModal("showRemark").open({ res }, function() {
                this.list = res.payload;
              });
            }
          }
        },
        {
          name: () => this.$t("Shipper Remark"),
          key: "portal_remarks",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("overseas") + this.$t("order_desc"),
          key: "warehouse_remarks",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("order_type"),
          key: "cod_type",
          align: "center",
          minWidth: 130,
          show: this.isShow
        },
        {
          name: () => this.$t("codAmount"),
          key: "cod_amount",
          align: "center",
          minWidth: 100
        },
        // {
        //   name: () => this.$t("exception_msg"),
        //   key: "exception_msg",
        //   align: "center",
        //   minWidth: 100
        // },
        {
          name: () => this.$t("des_goods"),
          key: "description",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("retired_times"),
          key: "delivery_number",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("called_times"),
          key: "miss_contact_time",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("refuse_number"),
          key: "refuse_number",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("not_update_time"),
          key: "not_update_time",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("tracker_code"),
          key: "tracker_status",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("tracker_description"),
          key: "status_remarks",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("new_tracker_time"),
          key: "status_time",
          align: "center",
          minWidth: 130,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("tracker_description_cn"),
          key: "tracker_description_cn",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("ExitExceptionRemark"),
          key: "quit_remarks",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("order_refCode"),
          key: "agent_refer_code",
          align: "center",
          minWidth: 140
        },
        {
          name: () => this.$t("auditOrder") + this.$t("order_desc"),
          key: "follow_remark",
          align: "center",
          minWidth: 140,
          show: () => {
            return this.tabName === "1";
          }
        },
        {
          name: () => this.$t("audit"),
          key: "follow_name",
          align: "center",
          minWidth: 100,
          show: () => {
            return this.tabName === "1";
          }
        },
        {
          name: () => this.$t("audit_time"),
          key: "follow_time",
          align: "center",
          minWidth: 140,
          show: () => {
            return this.tabName === "1";
          }
        },
        {
          name: () => this.$t("subplan") + this.$t("service"),
          key: "service_name_plan",
          align: "center",
          show: () => this.tabName === "1",
          minWidth: 80
        },
        // {
        //   name: () => this.$t("update") + this.$t("abnormal") + this.$t("time"),
        //   key: "update_time",
        //   align: "center",
        //   minWidth: 140
        //   // methods: {
        //   //   render({ value }) {
        //   //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
        //   //   }
        //   // }
        // },
        // {
        //   name: () => this.$t("shouldCallNum"),
        //   key: "should_call",
        //   align: "center",
        //   minWidth: 80
        // },
        // {
        //   name: () => this.$t("nowCallNum"),
        //   key: "call_num",
        //   align: "center",
        //   minWidth: 80
        // },
        // {
        //   name: () => this.$t("lastCallTime"),
        //   key: "last_call_time",
        //   align: "center",
        //   minWidth: 130,
        //   methods: {
        //     render({ value }) {
        //       return ~~value ? this.format.timeFormat(value * 1000) : "-";
        //     }
        //   }
        // }
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("followRecord"),
              type: "followRecord",
              fnName: "followRecordFun",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$t("abnormal") + this.$t("auditOrder"),
              type: "follow",
              fnName: "followFun",
              bind: {
                type: "success"
              },
              show: ({ row }) => {
                return this.tabName === "1" && row.is_follow;
              },
              id: 995
            },
            {
              name: () => this.$t("handle"),
              type: "handle",
              show: () => this.tabName === "0",
              bind: {
                type: "warning"
              },
              fnName: "handle",
              id: 1249
            },
            {
              name: () => this.$t("update"),
              type: "update",
              show: () => this.tabName === "1",
              disabled({ row }) {
                return (
                  row.plan_number !== "DELIVERY" || row.now_status == "FINISHED"
                );
              },
              bind: {
                type: "warning"
              },
              fnName: "update"
            },
            {
              name: () => "return to vnlin",
              type: "return",
              fnName: "returnFun",
              bind: {
                type: "warning"
              },
              show: () => !this.isShow()
            }
          ],

          methods: {
            returnFun({ row }) {
              this.$Modal.confirm({
                title: "return to vnlin",
                width: 300,
                content: "Do You Want To Do This?",
                onOk: () => {
                  this.handleRequestMethods(
                    "returnFun",
                    {
                      airway_number: row.airway_number
                    },
                    true
                  ).then(res => {
                    this.getList();
                  });
                }
              });
            },
            followFun({ row }) {
              this.getModal("follow").open({ id: row.id }, function() {
                this.setTitle(this.$t("abnormal") + this.$t("auditOrder"));
              });
            },
            update({ row }) {
              this.getModal("update").open(
                {
                  airway_number: row.airway_number,
                  country_code: row.country_code
                },
                function() {
                  this.setTitle(this.$t("update"));
                }
              );
            },
            followRecordFun({ row }) {
              this.getModal("showFollow").open(
                { id: row.airway_number },
                function() {
                  this.$page
                    .handleRequestMethods(
                      "getFollowList",
                      {
                        airway_number: row.airway_number
                      },
                      false,
                      true
                    )
                    .then(res => {
                      this.list = res.payload;
                    });
                  this.setTitle(
                    this.$t("exception_msg") + ": " + row.exception_msg_cn
                  );
                }
              );
            },
            handle({ row }) {
              this.getModal("errorHandle").open(
                {
                  order_id: row.airway_number,
                  toCountry: row.country_code,
                  plan: "",
                  radio: row.to_country,
                  is_pickup: row.is_pickup
                },
                function() {
                  this.type = "";
                  this.setTitle(
                    this.$t("handle") + this.$t("abnormal") + this.$t("order_t")
                  );
                }
              );
            }
          }
        }
      ]
    };
  }
};
</script>
